export default {
      id: "bell-outline-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#bell-outline-usage",
      toString: function () {
        return this.url;
      }
    }